import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'

import BlockFinancialResult from '../BlockFinancialResult/BlockFinancialResult'

export const StyledGovernanceTab = styled.div`
  gap: ${pxToRem(20)};
  flex-direction: column;
  display: flex;
  width: 100%;
  margin: 0 auto ${pxToRem(30)} auto;
  max-width: ${pxToRem(792)};
`

export const StyledBlockFinancialResult = styled(BlockFinancialResult)`
  margin-bottom: 0;
`

export const StyledBlockPresentation = styled.div`
  padding: ${pxToRem(20)};
  border-radius: ${pxToRem(5)};
  background-color: ${({ theme }) => theme.colors.unique.white};
`
